export const iconFontAwesomeAccessibilityPersonCane = (
	<i className="fa-solid fa-person-cane"></i>
);
